var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.showNotification)?_c('div',{class:_vm.notificationClass},[_vm._v(" "+_vm._s(_vm.notificationMessage)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }